import {observer} from "mobx-react";
import styled from "styled-components";
import {IoCloseSharp} from "react-icons/io5";
import {useStore} from "@/store";
import {SIZES} from "@/components/constants";
import MenuNavigationWrapMo from "@/app/homepage/layouts/components/MenuNavigationWrapMo";
import {usePathname, useRouter} from "next/navigation";
import BrandLogo from "/public/assets/images/logo/logo.png";
import MenuNavigationWrap from "@/app/homepage/layouts/components/MenuNavigationWrap";

const SideNav = observer(()=> {
    const {navigationStore} = useStore();
    const pathname = usePathname();
    const router = useRouter();
    const isHomepageRoot = pathname === "/homepage";
    return(
        <SideNavWrap
            className={`${navigationStore.sideNavigationOpen ? "active" : ""}`}
        >
            <SideNavHeader>
                <div className={"logo"} onClick={() => {
                    router.push("/homepage");
                }}>
                    <img src={BrandLogo?.src} alt={"로고"}/>
                </div>

                <div className={"header-control-wrap"}>
                    <div
                        className={`${!isHomepageRoot ? "page" : ""} mall-to`}
                        onClick={() => {
                            window.open("https://woongbee.shop/", "_blank", "noopener,noreferrer");
                        }}
                    >
                        <span>쇼핑몰 바로가기</span>
                    </div>
                    <div className={`toggle-btn ${!isHomepageRoot ? "page" : ""}`} onClick={() => {
                        navigationStore.setSideNavigationOpen(!navigationStore.sideNavigationOpen);
                    }}>
                        <IoCloseSharp color={"#000"} size={24}/>
                    </div>
                </div>
            </SideNavHeader>
            <NavListWrap
                onClick={() => {
                    navigationStore.setHeadActive(!navigationStore.headActive);
                }}
            >
                {/*<MenuNavigationWrapMo/>*/}
                <MenuNavigationWrap type={"mo"}/>
            </NavListWrap>
        </SideNavWrap>
    )
});
const SideNavHeader = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 1;
    height: 64px;
    padding: 0 25px 0 20px;
    justify-content: space-between;
    display: flex;
    align-items: center;
    .logo {
        width: 108px;
        cursor: pointer;
    }
    .header-control-wrap{
        display: flex;
        align-items: center;
        gap: 15px;
        .toggle-btn{
            cursor: pointer;
        }
        .mall-to{
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #564F67;
            border-radius: 99px;
            cursor: pointer;
            transition: color 0.3s ease, border-color 0.3s ease;
            color: #23203B;
            font-size: 14px;
            width: 114px;
            height: 28px;
            font-weight: 600;
            line-height: 18px;
            letter-spacing: 0.28px;
        }
    }
`
const SideNavWrap = styled.div`
    position: fixed;
    top: 0; 
    right: 0; 
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    background: #fff;
    z-index: 110;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    &.active{
        transform: translateX(0);
    }
    display: none;
    @media (max-width: ${SIZES.HEADER}) {
        display: block;
    }
`
const NavListWrap = styled.div.attrs(() => ({
    "data-lenis-prevent": "",
}))`
    margin-top: 64px;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
`;

export default SideNav
